import React from 'react';
import { PlusButton } from '@/views/QueryBuilder/subcomponents/PlusButton';
import Layer from './Layer';
import {
  WHERE,
  ORDER_BY,
  AGGREGATE,
  ADD_COLUMN,
  JOIN,
  TEMPLATE,
  SELECT,
  REARRANGE_COLUMNS,
  RENAME_COLUMNS,
  GROUP_BY,
} from '../../util/enums/EnumLayers';
import ModalWhere from '../modals/ModalWhere';
import ModalOrderBy from '../modals/ModalOrderBy';
import ModalAggregate from '../modals/ModalAggregate';
import ModalJoin from '../modals/ModalJoin';
import ModalAddColumn from '../modals/ModalAddColumn';
import ModalSelect from '../modals/ModalSelect';
import ModalGroupBy from '../modals/ModalGroupBy';
import ModalRenameColumns from '../modals/ModalRenameColumns';
import ModalRearrangeColumns from '../modals/ModalRearrangeColumns';

class TemplateLayer extends Layer {
  constructor(layerType) {
    super(TEMPLATE);
    this._layerType = layerType; // one of EnumLayers
  }

  layerType() {
    return this._layerType;
  }

  isTemplate() {
    return true;
  }

  modal() {
    switch (this.layerType()) {
      case WHERE:
        return ModalWhere;
      case ORDER_BY:
        return ModalOrderBy;
      case AGGREGATE:
        return ModalAggregate;
      case ADD_COLUMN:
        return ModalAddColumn;
      case JOIN:
        return ModalJoin;
      case SELECT:
        return ModalSelect;
      case RENAME_COLUMNS:
        return ModalRenameColumns;
      case REARRANGE_COLUMNS:
        return ModalRearrangeColumns;
      case GROUP_BY:
        return ModalGroupBy;
    }
  }

  title() {
    switch (this.layerType()) {
      case WHERE:
        return 'Filter rows';
      case ORDER_BY:
        return 'Sort rows';
      case AGGREGATE:
        return 'Summarize';
      case ADD_COLUMN:
        return 'Add new column';
      case JOIN:
        return 'Join table';
      case SELECT:
        return 'Show / hide columns';
      case RENAME_COLUMNS:
        return 'Rename columns';
      case REARRANGE_COLUMNS:
        return 'Reorder columns';
      case GROUP_BY:
        return 'Summarize as new column';
    }
  }

  buildContent(editLayerClicked) {
    return <PlusButton onClick={editLayerClicked} />;
  }
}

export default TemplateLayer;
